<template>
  <div class="onboarding_page">
    <h2>Vill ni använda er egna webbdomän för att skicka e-post?</h2>
    <p>En webbdomän är en egen .se eller .com domän t ex</p>
    <p>Ifall ni inte äger en egen domän kan ni skippa detta</p>
    <div class="segmented_select_container">
      
      <memlist-segmented-select-button 
        :parts="email_domain_options"
        :primary_color="'rgb(0 123 255)'"
        :secondary_color="'#ffffff'"
        @selected="on_email_domain_selection"
        :preselected_index="preselected_index"
      />
    </div>
    <div v-if="selected_email_domain === 'ja'" class="custom_email">
      
      <VerifyEmailDomainComponent 
      
      />

      <p class="mt-4">
        Du kan när som helst kontrollera status i "Inställningar" -> "E-post Domän"
      </p>
      
    </div>


    <div class="wizard_actions mt-4">
      <memlist-button variant="secondary" @click="prev_page">Tillbaka</memlist-button>
      <memlist-button variant="primary" :disabled="disabled_next" class="ml-8" @click="next_page">Fortsätt</memlist-button>
    </div>

  </div>
</template>

<script>
import VerifyEmailDomainComponent from '@/view/components/VerifyEmailDomainComponent.vue';


export default {
  name: 'onboarding_page5',
  props: ['onboarding_data'],
  emits: ['next_page','prev_page','update_data'],
  components: {
    VerifyEmailDomainComponent
  },
  computed: {
    disabled_next() {
      return !this.selected_email_domain;
    },
  },
  watch: {
    onboarding_data: {
      deep: true, // check properties of the form, not just the form reference (example.name for example)
      handler(val) {
        this.local_onboarding_data = { ...this.onboarding_data };
        this.selected_email_domain = this.local_onboarding_data.email_domain;

        const index = this.email_domain_options.findIndex(i => i.value === this.selected_email_domain);
        if (index >= 0) {
          this.preselected_index = index;
        }
      },
      immediate: true
    },
  },

  data() {
    return {
      preselected_index: null,
      local_onboarding_data: null,
      email_domain_options: [
        { value: 'ja', text: 'Ja' },
        { value: 'nej', text: 'Nej' },
        { value: 'kanske_senare', text: 'Kanske senare' }
      ],
      selected_email_domain: '',
      custom_email: ''
    }
  },
  methods: {
    on_email_domain_selection(value) {
      this.selected_email_domain = value
    },
    next_page() {
      this.local_onboarding_data.email_domain_shown = true;
      this.local_onboarding_data.email_domain = this.selected_email_domain;

      this.$emit('update_data', this.local_onboarding_data);
      this.$emit('next_page');
    },
    prev_page() {
      this.$emit('prev_page');
    }
  }
}
</script>

<style lang="scss" scoped>


.segmented_select_container {
  margin: 20px 0;
}

.custom_email {
  margin-top: 20px;
  display: block;
  width: 100%;
}


</style>
